import { InjectedConnector } from '@web3-react/injected-connector';

console.log('InjectedConnector', InjectedConnector, Number(process.env.REACT_APP_CHAIN_ID));

export const injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 44787, Number(process.env.REACT_APP_CHAIN_ID)],
});
